/**
 * Inline read more / read less for collection description previews.
 * Wrap markup in <collection-header-description class="collection-header__desc-expandable">…</collection-header-description>
 */
class CollectionHeaderDescription extends HTMLElement {
  /** @type {AbortController | null} */
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    const toggle = this.querySelector(".collection-header__desc-toggle");
    const rest = this.querySelector(".collection-header__desc-rest");
    const ellipsis = this.querySelector(".collection-header__desc-ellipsis");

    if (!toggle || !rest) return;

    toggle.addEventListener(
      "click",
      () => {
        const expanded = !this.classList.contains("is-expanded");
        this.classList.toggle("is-expanded", expanded);
        rest.hidden = !expanded;
        if (ellipsis) ellipsis.hidden = expanded;
        toggle.setAttribute("aria-expanded", String(expanded));
        toggle.textContent = expanded ? "Read less" : "Read more";
      },
      { signal },
    );
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
  }
}

const tag = "collection-header-description";

if (!customElements.get(tag)) {
  customElements.define(tag, CollectionHeaderDescription);
}
